import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Add } from '@factorialco/f0-react/icons/app'
import { runInAction } from 'mobx'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import FormEditor from 'modules/forms/components/FormEditor'
import { Form } from 'modules/forms/lib/Form'
import { extractFormFromQuizBlock } from 'modules/trainings/components/content/items/quiz/FormQuizHelper'
import { ContentViewProps } from 'modules/trainings/components/content/types'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

const QuizBlockView = observer(({ contentItem: quiz }: ContentViewProps<QuizBlock>) => {
  const [form, setForm] = useState<Form | undefined>(() => extractFormFromQuizBlock(quiz))
  const [showAddQuestionModal, setShowAddQuestionModal] = useState(false)

  useEffect(() => {
    setForm(extractFormFromQuizBlock(quiz))
  }, [quiz, quiz.form])

  const handleFormChange = (updatedForm: Form) => {
    setForm(updatedForm)

    if (quiz.form) {
      runInAction(() => {
        if (quiz.form) {
          quiz.form.title = updatedForm.title
          quiz.form.description = updatedForm.description
          quiz.form.elements = updatedForm.elements.map((element) => ({
            id: element.id || null,
            label: element.label,
            description: element.description || null,
            type: element.getType(),
            position: element.position,
            mandatory: element.mandatory,
            hasCorrectAnswer: element.hasCorrectAnswer,
            options: element.options.map((option) => ({
              id: option.id || null,
              label: option.label,
              value: option.value,
              isCorrect: option.isCorrect,
            })),
          }))
        }
      })
    }
  }

  if (!form) {
    return null
  }

  return (
    <Box width="full" paddingX="s24">
      <Box paddingX="s16" gap="s8">
        <ResourceHeader title={quiz.title} description={form?.description || undefined} />
      </Box>
      {quiz.form && quiz.form?.elements.length > 0 && (
        <Box flexDirection="row" gap="s8" justifyContent="flexEnd" paddingX="s16">
          <F0Button
            onClick={() => setShowAddQuestionModal(true)}
            icon={Add}
            variant="outline"
            label={i18n.t('trainings.content.block.quiz.add_question')}
          />
        </Box>
      )}

      <FormEditor
        form={form}
        setForm={handleFormChange}
        hideSidebar
        showAllElements
        showAddQuestionModal={showAddQuestionModal}
        onCloseAddQuestionModal={() => setShowAddQuestionModal(false)}
        permittedFieldTypes={quiz.form?.configuration?.allowedElements || ['select', 'multiselect']}
      />
    </Box>
  )
})

export default QuizBlockView
